import { clsx } from 'clsx'

import { ContentRenderer } from '../Components/ContentRenderer.js'
import { MediaRenderer } from '../Components/MediaRenderer.js'
import { type HeroBannerProps } from '../types.js'
import { getContentSpacingClass } from '../utils/utils.js'

interface LeftRightLayoutProps extends HeroBannerProps {
  reverse?: boolean
}
export const LeftRightLayout = ({
  contentSpacing,
  eyebrow,
  heading,
  description,
  textColor,
  textAlignment,
  mediaType,
  image,
  video,
  mediaTint,
  backgroundColor,
  className,
  actionType,
  reverse,
  buttonActions,
  searchAction,
  ...rest
}: LeftRightLayoutProps) => {
  const spacingClass = getContentSpacingClass(contentSpacing)

  return (
    <div
      className="@container"
      data-block-id={rest['data-block-id']}
      data-block-name={rest['data-block-name']}
    >
      <div
        className={clsx(
          className,
          'flex rounded-base overflow-hidden',
          'rounded-screen-none',
          reverse
            ? 'flex-col-reverse @3xl:flex-row-reverse'
            : 'flex-col @3xl:flex-row',
        )}
        style={{ backgroundColor }}
      >
        <div className="@3xl:flex-1">
          <ContentRenderer
            actionType={actionType}
            buttonActions={buttonActions}
            searchAction={searchAction}
            textColor={textColor}
            textAlignment={textAlignment}
            eyebrow={eyebrow}
            heading={heading}
            description={description}
            className={clsx('px-6 @3xl:px-10 @5xl:px-16', spacingClass)}
          />
        </div>
        <div
          className={clsx('aspect-video @3xl:aspect-auto @3xl:flex-1 relative')}
        >
          <MediaRenderer
            mediaType={mediaType}
            image={image}
            video={video}
            mediaTint={mediaTint}
            textColor={textColor}
          />
        </div>
      </div>
    </div>
  )
}
